import { render, staticRenderFns } from "./PageSetting.vue?vue&type=template&id=6dfb0f3a&scoped=true&"
import script from "./PageSetting.vue?vue&type=script&lang=js&"
export * from "./PageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb0f3a",
  null
  
)

export default component.exports